module.exports = __webpack_public_path__ + "img/plant-a-tree.6819c7cd.png";